import { createSlice } from "@reduxjs/toolkit";

export const filterPayloadSlice = createSlice({
  name: "filterPayloadSlice",
  initialState: {
    globalFilters: null,
  },
  reducers: {
    setFilterPayload: (state, action) => {
      state.globalFilters = action.payload;
    },
    clearFilterPayload: (state, action) => {
      state.globalFilters = null;
    },
  },
});

export const { setFilterPayload, clearFilterPayload } =
  filterPayloadSlice.actions;

export default filterPayloadSlice.reducer;
